<div [dir]="direction">
  <div (click)="returnToLogin()" class="ar-header">
    <vue-login-header></vue-login-header>
  </div>
  <div id="skip-link">
    <a [href]="skipLinkPath" class="skip" id="skipAnchor" title="{{ 'AppComponent.skipToMainContentLabel' | translate:'AccountRecovery' | async }}" tabindex="0">{{ 'AppComponent.skipToMainContentLabel' | translate:'AccountRecovery' | async}}</a>
  </div>
  <div id="main-content" role="main">
    <vue-loading-indicator loadingText="{{ 'label.loading' | translate:'PortalBase' | async }}"></vue-loading-indicator>
    <div class="app-wrapper">
      <div class="app-container">
        <vue-panel idSuffix="-main">
          <router-outlet></router-outlet>
        </vue-panel>
      </div>
    </div>
  </div>
  <vue-footer></vue-footer>
</div>
